import React from "react"
import { PropTypes } from "prop-types"
import { CSVLink } from 'react-csv'
import { Row, Col, Button, FormGroup, ControlLabel, FormControl, InputGroup } from "react-bootstrap"
import { orange, green, blue } from '../../utils/constants'
import { SearchByEnum, UserListHeaders } from '../../containers/userManagement/constants'

const UserSearch = (props) => {
  const {
    userList,
    searching,
    isSelect,
    generateReport,
    setSearchTextField,
    setSelectValues,
    handleSearch,
    handleSearchByChange,
    handleGenerateUserList,
    handleAddUser
  } = props;
  return (
    <React.Fragment>
    <div className="content-heading" >User Management </div >
    <Row>
      <Col sm={12}>
        <div className="stacked-filter-panel">
          <FormGroup controlId="searchby" className="searchby-filter">
            <ControlLabel style={{ minWidth: '75px' }}>Search By:</ControlLabel>
            <FormControl defaultValue={SearchByEnum.Status
            } componentClass="select" placeholder="All" onChange={handleSearchByChange} style={{
              minWidth: '125px',
              borderRadius: '0'
            }}>
              <option value={SearchByEnum.All}>All</option>
              <option value={SearchByEnum.FirstName}>First name</option>
              <option value={SearchByEnum.LastName}>Last name</option>
              <option value={SearchByEnum.Email}>Email</option>
              <option value={SearchByEnum.Status}>Status</option>
              <option value={SearchByEnum.Role}>Role</option>
            </FormControl>
            <InputGroup>
              {
                isSelect === false && setSearchTextField()
              }
              {
                isSelect === true && setSelectValues()
              }
              <InputGroup.Button>
                <Button onClick={handleSearch} style={{ color: orange, borderRadius: '0' }}>
                  <i className={searching === true ? "fa fa-spinner fa-spin" : "fa fa-search"
                  } aria-hidden="true" />
                </Button>
              </InputGroup.Button>
              <InputGroup.Button>
                {
                  (generateReport === true) &&
                  (<Button style={{ color: blue }}>
                    <CSVLink
                      data={userList}
                      headers={UserListHeaders}
                      filename='Junior Gold User List.csv'
                      target='_blank'
                      style={{ color: 'green' }}
                    >
                      <i className="fa fa-file-excel-o" aria-hidden="true" />&nbsp;&nbsp;<span onClick={handleGenerateUserList}>Export ( .csv )</span>
                    </CSVLink>
                  </Button>)
                }
                {
                  (generateReport === false) &&
                  (<Button disabled style={{ color: blue }}>
                    <i className="fa fa-file-excel-o" aria-hidden="true" />&nbsp;&nbsp;<span>Export ( .csv )</span>
                  </Button>)
                }
              </InputGroup.Button>
              <InputGroup.Button>
                <Button onClick={handleAddUser} style={{ color: green, borderRadius: '0' }}>
                  <i className="fa fa-user-o" aria-hidden="true" />&nbsp;&nbsp;Add User
                      </Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
        </div>
      </Col>
    </Row>
    </React.Fragment>
  );
}

UserSearch.propTypes = {
  userList: PropTypes.array,
  searching: PropTypes.bool,
  isSelect: PropTypes.bool,
  generateReport: PropTypes.bool,
  setSearchTextField: PropTypes.func,
  setSelectValues: PropTypes.func,
  handleSearch: PropTypes.func,
  handleSearchByChange: PropTypes.func,
  handleGenerateUserList: PropTypes.func,
  handleAddUser: PropTypes.func
};

export default UserSearch;


// WEBPACK FOOTER //
// ./src/components/userSearch/index.js